export default __webpack_public_path__ + "static/media/TopicTip_Emojis.6fbb68ba.svg";